import styledImport from 'styled-components';
import type { ThemedStyledInterface } from 'styled-components';

import { Type } from '../../../app/StyleGuide';
import type { NavbarTheme } from '../state/Navbar.theme';

const styled = styledImport as ThemedStyledInterface<NavbarTheme>;

export const AuthPillButton = styled.button<{ $variant: 'primary' | 'secondary' }>`
  border-radius: 999px;
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === 'primary' ? theme.primaryButtonBackground : theme.secondaryButtonBorderColor};
  background: ${({ theme, $variant }) =>
    $variant === 'primary' ? theme.primaryButtonBackground : theme.secondaryButtonBackground};
  color: ${({ theme, $variant }) => ($variant === 'primary' ? theme.primaryButtonColor : theme.secondaryButtonColor)};
  font-weight: ${Type.Weight.semibold};
  transition: background-color 0.125s linear, color 0.125s linear, border-color 0.125s linear;

  &:hover,
  &:focus {
    color: ${({ theme, $variant }) => ($variant === 'primary' ? theme.primaryButtonColor : theme.secondaryButtonColor)};
    text-decoration: none;
  }

  ${({ theme, $variant }) =>
    $variant === 'primary'
      ? `
    &:hover,
    &:focus,
    &:active {
      background: ${theme.primaryButtonHoverBackground};
      border-color: ${theme.primaryButtonHoverBackground};
    }
  `
      : ''}

  margin: ${Type.Scale._05};
  padding: 0 ${Type.Scale._4};
  height: 100%;
  font-size: ${Type.Scale._2};
`;
